import { render, staticRenderFns } from "./loantypes.vue?vue&type=template&id=500fc192"
import script from "./loantypes.vue?vue&type=script&lang=js"
export * from "./loantypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports